/* eslint-disable react/prop-types */
import React, { Suspense, useMemo } from "react";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import { ArrowUpward } from "@mui/icons-material";
import DefaultProvider, { useLayout } from "../../_context/DefaultProvider";
import ErrorBox from "../../_default/ErrorBox";
import LoadingBox from "../../_default/LoadingBox";
import ScrollTop from "./ScrollTop";
import FooterSection from "./footer";
import HeaderSection from "./header";
import MainSection from "./MainSection";
import { motion } from "framer-motion";
import ScreenSizeProvider, {
  useScreenSize,
} from "../../_context/ScreenSizeProvider";
import MenuButton from "./MenuButton";

const DefaultLayout = (props) => {
  const { children } = props;

  if (typeof window === "undefined") {
    return null;
  }

  if (React.Children.count(children) === 0) {
    console.warn("Default Layout expects at least one child.");
    return null;
  }

  return React.isValidElement(children) ? (
    <DefaultProvider>
      <ScreenSizeProvider>
        <Suspense
          fallback={
            <LoadingBox
              isLoading={true}
              text={"Adjusting layout for optimal ..."}
            />
          }
        >
          <Page {...props} />
        </Suspense>
      </ScreenSizeProvider>
    </DefaultProvider>
  ) : null;
};
const Page = (props) => {
  const { title, description, isFooterHome, children } = props;
  const { isResizing, width } = useScreenSize();
  
  const {
    error,
    isError,
    isLoading,
    drawerStates,
    visibility,
    handleOpenDrawerDefault,
    handleCloseDrawer,
  } = useLayout();

  const childrenWithProps = React.Children.map(children, (child) => {
    return React.cloneElement(child, {});
  });
  const result = useMemo(() => {
    return drawerStates?.isLeftMenuOpen? !drawerStates?.isExpanded:visibility?.showMenuIcon 
  }, [visibility?.showMenuIcon, drawerStates]);

  return (
    <Box
      componnent="div"
      id="site-frontend-main"
      style={{
        position: "relative",
        padding: "0px",
        margin: "0px",
        boxSizing: "border-box",
        width: `${width}px`,
        maxWidth: `${width}px`,
        overflowX: "hidden",
      }}
    >
      <HeaderSection title={title} description={description} />

        {
        result ? <MenuButton
        istop={true}
        handleClick={() =>
          !drawerStates?.isLeftMenuOpen
            ? handleOpenDrawerDefault("isLeftMenuOpen")
            : handleCloseDrawer("isLeftMenuOpen")
        }
        visibility={visibility}
      />:null}
     
   
      <Box
        componnent="main"
        id="site-main-section"
        style={{
          position: "relative",
          padding: "0px",
          margin: "0px",
          boxSizing: "border-box",
          width: "100%",

          overflowX: "hidden",
        }}
      >
        <LoadingBox isLoading={isLoading} text={"Loading..."} />
        <LoadingBox
          isLoading={isResizing}
          text={"Adjusting layout for optimal display..."}
        />

        <MainSection childrenWithProps={childrenWithProps} />
        <ErrorBox isError={isError} error={error} />
        <ScrollTop {...props}>
          <Fab
            aria-label="scroll back to top"
            color="primary"
            style={{ padding: 0, margin: 0, width: "50px", height: "50px" }}
          >
            <ArrowUpward
              style={{ padding: 0, margin: 0, width: "40px", height: "40px" }}
            />
          </Fab>
        </ScrollTop>
      </Box>

      <FooterSection isFooterHome={isFooterHome} />
    </Box>
  );
};

export default DefaultLayout;
